(function (globalScope, factory) {
  const api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (globalScope) globalScope.HomeWellnessBaselineEngine = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  const QUIZ_VERSION = "home_wellness_baseline_v2026_09_08";
  const CONTENT_VERSION = "home_wellness_baseline_results_v2026_09_08";
  const PARKED_QUESTION_IDS = Object.freeze([
    "home_setup",
    "food_storage",
    "cleaning_laundry_products",
    "water_source",
    "water_filter",
    "pest_lawn_outdoor",
    "kids_toys",
    "kids_pajamas",
    "top_concerns"
  ]);
  const FREE_RESULT_KEYS = Object.freeze([
    "kitchenPlastics",
    "nonstick",
    "fragrance",
    "pfasFabrics",
    "dust",
    "indoorAir",
    "mold",
    "kidsPlastics",
    "maintenance"
  ]);
  const PRO_ONLY_RESULT_KEYS = Object.freeze([
    "cleaningLaundry",
    "water",
    "pesticides",
    "kidsToys",
    "kidsTextiles",
    "textiles"
  ]);
  const CROSS_CONTRIBUTION_PFAS_REASON = "Some answers can point to more than one materials question. If you are buying clothing or furnishings, checking advertised finishes is a useful next step.";

  const DEFAULT_RESOURCES = {
    aapPlasticizersResearch: { label: "AAP: plastic additives and heating guidance", url: "https://www.aap.org/en/patient-care/environmental-health/promoting-healthy-environments-for-children/plasticizers/", type: "research" },
    foodMigrationResearch: { label: "Review: migration from food packaging into food", url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC12096275/", type: "research" },
    niehsEndocrineResearch: { label: "NIEHS: endocrine disruptors overview", url: "https://www.niehs.nih.gov/health/topics/agents/endocrine", type: "research" },
    epaIndoorAirResearch: { label: "EPA: Improving Indoor Air Quality", url: "https://www.epa.gov/indoor-air-quality-iaq/improving-indoor-air-quality", type: "research" },
    fdaFragranceResearch: { label: "FDA: Fragrances in Cosmetics", url: "https://www.fda.gov/cosmetics/cosmetic-ingredients/fragrances-cosmetics", type: "research" },
    atsdrPfasResearch: { label: "ATSDR: How PFAS Impacts Your Health", url: "https://atsdr.cdc.gov/pfas/about/health-effects.html", type: "research" },
    atsdrPfasHealthResearch: { label: "ATSDR: How PFAS Impacts your Health", url: "https://www.atsdr.cdc.gov/pfas/about/health-effects.html", type: "research" },
    bfrPtfeResearch: { label: "BfR's 2025 PTFE cookware assessment", url: "https://www.bfr.bund.de/en/service/frequently-asked-questions/topic/selected-questions-and-answers-on-cookware-ovenware-and-frying-pans-with-a-non-stick-coating-made-of-ptfe", type: "research" },
    ifraTransparencyResearch: { label: "IFRA Transparency List", url: "https://ifrafragrance.org/transparency-list", type: "research" },
    ewgFragranceResearch: { label: "EWG News & Insights: 3,163 Ingredients Hide Behind the Word \"Fragrance\"", url: "https://www.ewg.org/news-insights/news/3163-ingredients-hide-behind-word-fragrance", type: "research" },
    epaPfasResearch: { label: "EPA: PFAS", url: "https://www.epa.gov/pfas/our-current-understanding-human-health-and-environmental-risks-pfas", type: "research" },
    microfiberResearch: { label: "De Falco et al.: microfiber release", url: "https://pubs.acs.org/doi/10.1021/acs.est.9b06892", type: "research" },
    textileBisphenolsResearch: { label: "Textile bisphenols", url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC11415442/", type: "research" },
    epaPesticidesIndoorAirResearch: { label: "EPA: Pesticides and indoor air quality", url: "https://www.epa.gov/indoor-air-quality-iaq/pesticides-impact-indoor-air-quality", type: "research" },
    epaWildfireIaqResearch: { label: "EPA: Wildfires and Indoor Air Quality (IAQ)", url: "https://www.epa.gov/emergencies-iaq/wildfires-and-indoor-air-quality-iaq", type: "research" },
    cdcCarbonMonoxideResearch: { label: "CDC: Carbon monoxide prevention", url: "https://www.cdc.gov/carbon-monoxide/about/index.html", type: "research" },
    epaMoistureControlResearch: { label: "EPA: Main ways to control moisture", url: "https://www.epa.gov/mold/what-are-main-ways-control-moisture-your-home", type: "research" },
    cdcBreastMilkResearch: { label: "CDC: Breast milk handling and storage", url: "https://www.cdc.gov/breastfeeding/breast-milk-preparation-and-storage/handling-breastmilk.html", type: "research" },
    kitchenHazardsLearn: { label: "The Top 10 Hidden Hazards in Your Kitchen (Ranked by Harm)", url: "/blogs/learn/the-top-10-hidden-hazards-in-your-kitchen-ranked-by-harm", type: "learn" },
    fragranceIndoorAirLearn: { label: "When Clean Became a Scent: What Fragrance Is Adding to Your Indoor Air", url: "/blogs/learn/fragrance-indoor-air", type: "learn" },
    hiddenAirLearn: { label: "The Hidden Air You Breathe", url: "/blogs/learn/the-hidden-air-you-breathe", type: "learn" },
    hormoneTimelineLearn: { label: "Why Childhood May Be the Most Important Time to Reduce Everyday Chemical Exposures", url: "/blogs/learn/the-hormone-timeline-why-everyday-chemical-exposures-matter-most-during-development", type: "learn" }
  };

  const DEFAULT_PRO_FALLBACK = {
    state: "prelaunch",
    eyebrow: "Keep building",
    headline: "Keep building your home’s bigger picture.",
    why: "This short Baseline covers a selected set of everyday routines. It is a starting point—not a complete assessment of your home.",
    guidanceLabel: "General guidance",
    guidanceText: "This is broader educational guidance, not an additional exposure finding. Pro availability does not change your score.",
    beforeBody: "Keep building with our practical Learn articles. Home Wellness Score Pro is coming for a personalized room-by-room assessment at the spaces, products, and routines inside and outside your home. Join the waitlist for launch updates.",
    afterBody: "Explore Home Wellness Score Pro for a personalized room-by-room look at your home—from water and laundry to children’s products and outdoor routines—and practical guidance on where to begin.",
    beforeAction: "Keep one practical habit going, and join the Home Wellness Score Pro waitlist if you’d like to hear when a broader assessment is ready.",
    afterAction: "Explore Home Wellness Score Pro when you’re ready for a broader look at your home.",
    beforeCtaLabel: "Join the Score Pro waitlist",
    afterCtaLabel: "Explore Home Wellness Score Pro"
  };

  const PREPARATION_RESULT = {
    key: "kidsPlastics",
    variant: "preparation",
    tag: "Planning for baby",
    title: "Build a simple feeding setup.",
    why: "You told us you’re preparing for a baby. This is planning guidance, not a finding about an exposure in your home.",
    action: "Before buying a full set, compare a few feeding items for intended use, durability, and easy cleaning. Glass bottles are one option where practical; follow the maker’s instructions and your care team’s feeding advice.",
    evidenceLabel: "Planning guidance",
    evidenceNote: "This is preparation advice, not a scored exposure finding.",
    whyParagraphs: [
      "You told us you’re preparing for a baby. This is planning guidance, not a finding about an exposure in your home.",
      "Before buying a full set, compare intended use, durability, and cleaning instructions. A material label alone does not establish safety."
    ],
    products: [],
    resources: ["kitchenHazardsLearn", "hormoneTimelineLearn"],
    research: ["aapPlasticizersResearch", "foodMigrationResearch", "cdcBreastMilkResearch"]
  };

  function hasAny(values, targets) {
    const arr = Array.isArray(values) ? values : [];
    return targets.some(value => arr.includes(value));
  }

  function kidsDishwareEligible(answers) {
    return hasAny(answers && answers.household_profile, ["babies_young_children", "school_age_teens", "pregnancy_planning"]);
  }

  function isPregnancyOnlyHousehold(answers) {
    const household = Array.isArray(answers && answers.household_profile) ? answers.household_profile : [];
    return household.includes("pregnancy_planning") && !hasAny(household, ["babies_young_children", "school_age_teens"]);
  }

  function optionVisible(option, answers) {
    if (!option || !option.visibleWhen) return true;
    if (option.visibleWhen === "household_profile includes pregnancy_planning") {
      return hasAny(answers && answers.household_profile, ["pregnancy_planning"]);
    }
    return true;
  }

  function questionTitle(question, answers) {
    if (question && question.id === "kids_dishware" && question.pregnancyOnlyTitle && isPregnancyOnlyHousehold(answers)) {
      return question.pregnancyOnlyTitle;
    }
    return question && question.title ? question.title : "";
  }

  const QUESTIONS = [
    {
      id: "household_profile", type: "multi", section: "Household",
      title: "Which best describes your household right now?",
      help: "Choose all that apply, including people who stay regularly.",
      insight: "A home is not one-size-fits-all. Kids, pregnancy, pets, older adults, and sensitivities can change which small resets are most protective and realistic first.",
      note: "Choose all that apply.",
      researchLinks: [
        { label: "AAP: children and plastic additives", url: "https://www.aap.org/en/patient-care/environmental-health/promoting-healthy-environments-for-children/plasticizers/" },
        { label: "NIEHS: endocrine disruptors overview", url: "https://www.niehs.nih.gov/health/topics/agents/endocrine" }
      ],
      options: [
        { label: "Babies or young children", value: "babies_young_children", risk: 0, categories: {} },
        { label: "School-age kids or teens", value: "school_age_teens", risk: 0, categories: {} },
        { label: "Pregnancy or planning for pregnancy", value: "pregnancy_planning", risk: 0, categories: {} },
        { label: "Pets", value: "pets", risk: 0, categories: {} },
        { label: "Allergies, asthma, or chemical sensitivities", value: "allergies_asthma_sensitivities", risk: 0, categories: {} },
        { label: "Immunocompromised household member", value: "immunocompromised", risk: 0, categories: {} },
        { label: "Older adults (65+)", value: "older_adults", risk: 0, categories: {} },
        { label: "None of these", value: "none", risk: 0, categories: {}, exclusive: true }
      ]
    },
    {
      id: "microwave_plastic", section: "Kitchen + Food",
      title: "How often does warm or hot food or drink touch plastic—including plastic-lined cups, containers, or cooking bags?",
      help: "Include reheating, hot drinks, takeaway containers, microwave meal trays, and sous-vide bags—not just microwaving.",
      insight: "AAP guidance recommends avoiding heating food or drinks in plastic when possible. Starting with the heating step is simple, concrete, and does not require replacing everything.",
      researchLinks: [
        { label: "AAP: avoid heating food or drinks in plastic", url: "https://www.aap.org/en/patient-care/environmental-health/promoting-healthy-environments-for-children/plasticizers/" },
        { label: "Review: food packaging and chemical migration", url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC12096275/" }
      ],
      options: [
        { label: "Often — several times per week", value: "often", risk: 5, categories: { kitchenPlastics: 5 } },
        { label: "Sometimes — a few times per month", value: "sometimes", risk: 3, categories: { kitchenPlastics: 3 } },
        { label: "Rarely — only occasionally", value: "rarely", risk: 1, categories: { kitchenPlastics: 1 } },
        { label: "Never — as far as I know", value: "never", risk: 0, categories: { kitchenPlastics: 0 } }
      ]
    },
    {
      id: "kids_dishware", section: "Kids",
      title: "Which best describes the bottles, cups, dishes, and utensils your children use?",
      pregnancyOnlyTitle: "Which best describes your family’s current use of baby bottles and feeding items?",
      help: "Answer for the child whose feeding items you use most. Preparing for a baby? Choose “Not in use yet” if these routines have not started.",
      insight: "Feeding items are a repeated food-contact routine. Focus first on items used with warm food or liquids. If you are preparing for a baby, compare intended use, durability, and cleaning instructions before buying a full set.",
      condition: answers => kidsDishwareEligible(answers),
      options: [
        { label: "Mostly plastic or melamine", value: "plastic", risk: 5, categories: { kidsPlastics: 5, kitchenPlastics: 2 } },
        { label: "A mix of plastic, silicone, stainless, and ceramic", value: "mixed", risk: 3, categories: { kidsPlastics: 3, kitchenPlastics: 1 } },
        { label: "Mostly stainless, silicone, glass, or ceramic", value: "mostly_safer", risk: 1, categories: { kidsPlastics: 1 } },
        { label: "Stainless/glass/ceramic for food; silicone as needed", value: "best", risk: 0, categories: { kidsPlastics: 0 } },
        { label: "Not in use yet—we’re preparing for a baby.", value: "not_in_use_yet", risk: null, categories: {}, unscored: true, excludeFromDenominator: true, visibleWhen: "household_profile includes pregnancy_planning" }
      ]
    },
    {
      id: "nonstick_cookware", section: "Kitchen + Food",
      title: "How often do you use nonstick cookware or coated appliances?",
      help: "Include your most-used nonstick or ceramic-coated pans, bakeware, air-fryer baskets, rice-cooker inserts, waffle makers, and similar appliances.",
      insight: "PFAS have been used for nonstick and stain-resistant properties. Prioritizing safe replacements of scratched, peeling, older, or high-heat nonstick is a focused first step — not a full cookware overhaul. Newer PFAS-free ceramic nonstick can be a better fit than older Teflon-style pans, but it should be replaced at the first sign of wear.",
      options: [
        { label: "Daily, including scratched or older pans", value: "daily_scratched", risk: 5, categories: { nonstick: 5, pfasFabrics: 1 } },
        { label: "Daily, but pans are newer and intact", value: "daily_intact", risk: 4, categories: { nonstick: 4 } },
        { label: "A few times per week", value: "weekly", risk: 3, categories: { nonstick: 3 } },
        { label: "Rarely or never — mostly stainless, cast iron, carbon steel, or glass", value: "rarely", risk: 0, categories: { nonstick: 0 } }
      ]
    },
    {
      id: "fragrance_routine", section: "Fragrance + Air",
      title: "How often do fragrance products show up in your daily home or body routine?",
      help: "Include scented body care, laundry and cleaning products, candles, and air fresheners.",
      insight: "“Fragrance” or “parfum” on a label can represent many undisclosed ingredients. Some common fragrance-related chemicals, including certain phthalates, are studied as endocrine disruptors. Going fragrance-free is often one of the simplest, lowest-cost resets.",
      researchLinks: [
        { label: "NIEHS: endocrine disruptors", url: "https://www.niehs.nih.gov/health/topics/agents/endocrine" },
        { label: "Study: endocrine-disrupting chemicals in household products", url: "https://www.sciencedirect.com/science/article/pii/S0147651322005176" }
      ],
      options: [
        { label: "Daily — personal fragrance and/or home scent are part of our routine", value: "daily", risk: 5, categories: { fragrance: 5, indoorAir: 2 } },
        { label: "A few times per week", value: "weekly", risk: 3, categories: { fragrance: 3, indoorAir: 1 } },
        { label: "Occasionally", value: "occasionally", risk: 1, categories: { fragrance: 1 } },
        { label: "Rarely/never — mostly fragrance-free", value: "rarely_never", risk: 0, categories: { fragrance: 0 } }
      ]
    },
    {
      id: "shoes_dust", section: "Shoes + dust",
      title: "How do you manage outdoor shoes and dust in your home?",
      help: "Choose your usual weekly routine, including shoes or work clothes coming in from outdoors.",
      insight: "Dust comes from indoors and outdoors. Shoes can bring in soil and residues from lawn or pest treatments where those products are used. This question identifies a routine, not whether pesticides are present in your home.",
      options: [
        { label: "Outdoor shoes often stay on indoors; dusting or vacuuming is irregular.", value: "higher", risk: 4, categories: { dust: 4 } },
        { label: "Outdoor shoes sometimes stay on indoors; we dust or vacuum weekly.", value: "medium", risk: 2, categories: { dust: 2 } },
        { label: "Outdoor shoes mostly come off; we regularly damp-dust and vacuum.", value: "low", risk: 1, categories: { dust: 1 } },
        { label: "Outdoor shoes come off; we use entry mats, damp-dust, and vacuum with a HEPA filter.", value: "best", risk: 0, categories: { dust: 0 } }
      ]
    },
    {
      id: "treated_textiles_furnishings", section: "Fabrics + finishes",
      title: "Do you use clothing or home furnishings advertised as stain-resistant, water-repellent, or “performance” fabric?",
      help: "Think about clothing, sofas, rugs, and other frequently used fabrics. Answer about the finish, not just the fiber.",
      insight: "The fiber and the finish are different. Polyester garments can shed microfibers, but a polyester or moisture-wicking label does not prove PFAS are present. Check fiber labels and advertised treatments separately; a “performance” label alone is not proof either.",
      options: [
        { label: "Yes — several items", value: "yes_several", risk: 5, categories: { pfasFabrics: 5 } },
        { label: "One or two items", value: "one_two", risk: 3, categories: { pfasFabrics: 3 } },
        { label: "Not sure", value: "unsure", risk: 0, categories: {} },
        { label: "No — untreated natural materials or verified PFAS-free options", value: "no", risk: 0, categories: { pfasFabrics: 0 } }
      ]
    },
    {
      id: "ventilation", section: "Indoor Air",
      title: "How often do you ventilate during cooking, cleaning, or new-product smells?",
      help: "Think about cooking, cleaning, and new-product smells when outdoor air is clean and conditions allow.",
      insight: "EPA highlights source control, ventilation, and filtration as key indoor-air strategies. This question helps find your simplest air-quality lever.\n\nA safety reminder for every home: never run a car in an attached garage, even with the door open. Use portable generators outdoors, more than 20 feet from doors, windows, and vents. Install carbon monoxide alarms near sleeping areas and follow their testing instructions.",
      options: [
        { label: "Rarely — we usually keep everything closed up", value: "rarely", risk: 4, categories: { indoorAir: 4 } },
        { label: "Sometimes — for some of these moments", value: "sometimes", risk: 2, categories: { indoorAir: 2 } },
        { label: "Often — especially cooking and cleaning", value: "often", risk: 1, categories: { indoorAir: 1 } },
        { label: "Very intentionally — vented hood/HEPA/open windows when appropriate", value: "intentional", risk: 0, categories: { indoorAir: 0 } }
      ]
    },
    {
      id: "moisture_mold", section: "Moisture + Mold",
      title: "Any recurring moisture, musty smells, visible mold, leaks, or condensation issues?",
      help: "Think bathrooms, under sinks, basements, laundry rooms, windows, and HVAC areas.",
      insight: "Moisture problems are worth prioritizing because they can affect indoor air quality and may require source control.",
      options: [
        { label: "Yes — recurring or unresolved", value: "yes", risk: 5, categories: { mold: 5, indoorAir: 2 } },
        { label: "Maybe — occasional musty smell or condensation", value: "maybe", risk: 3, categories: { mold: 3 } },
        { label: "Past issue, fixed and monitored", value: "past", risk: 1, categories: { mold: 1 } },
        { label: "No known issues", value: "no", risk: 0, categories: { mold: 0 } }
      ]
    },
    {
      id: "readiness_budget", section: "Goals",
      title: "What kind of next step feels most realistic right now?",
      help: "Choose what feels realistic for the next few weeks, not forever.",
      insight: "Progress sticks when the next step feels doable. We use this to frame your recommendations gently — not to score you down.",
      options: [
        { label: "Free or no-cost changes only", value: "free_low_cost", risk: 0, categories: {} },
        { label: "Low-cost swaps under $100", value: "under_100", risk: 0, categories: {} },
        { label: "A focused room reset / $100–$300", value: "room_reset", risk: 0, categories: {} },
        { label: "Ready to invest in the highest-impact upgrades", value: "highest_impact", risk: 0, categories: {} },
        { label: "I’m not sure yet", value: "not_sure", risk: 0, categories: {} }
      ]
    }
  ];

  const CATEGORY_REASSURANCE = {
    kitchenPlastics: {
      good: "You already have at least one lower-plastic food routine in place, which gives your kitchen a helpful foundation.",
      calm: "You do not need to replace every container today. Focus on heat, warm leftovers, and daily food-contact items first."
    },
    nonstick: {
      good: "You are not starting from scratch on cookware — your highest-use pan is simply the first place to look.",
      calm: "You do not need a full cookware overhaul right now. One most-used or scratched nonstick item is enough to prioritize first."
    },
    fragrance: {
      good: "You already have room to simplify fragrance exposure without changing everything about your routines.",
      calm: "You do not need to throw out every scented item today. Start with the daily products that touch skin, bedding, or indoor air most often."
    },
    pfasFabrics: {
      good: "You do not need to panic-replace furniture or rugs. Awareness is the first useful step.",
      calm: "Treated fabrics are not usually the first thing to replace. Avoiding new treated purchases is a calmer place to begin."
    },
    dust: {
      good: "Any shoes-off, entry mat, damp dusting, or vacuuming habit you already have is doing more than it may seem.",
      calm: "You do not need a perfect cleaning schedule. A few repeatable dust habits matter more than occasional deep cleaning."
    },
    indoorAir: {
      good: "You already have practical air-quality levers available: source control, ventilation, and filtration when it makes sense.",
      calm: "You do not need to test every air contaminant right away. Start by reducing the indoor inputs you can control."
    },
    mold: {
      good: "If you do not have recurring moisture or musty smells, mold does not need to become your first focus today.",
      calm: "Mold and moisture deserve attention when signs are present, but they do not need to overshadow your highest-impact everyday changes."
    },
    kidsPlastics: {
      good: "You are already looking at the kid items that matter most: warm food contact, mouthing, and long daily use.",
      calm: "You do not need to replace the whole playroom or kitchen drawer. Start with the items used with warm food every day."
    }
  };

  const RECOMMENDATION_DEFAULTS = {
    maintenance: {
      key: "maintenance",
      tag: "Keep building",
      title: "Keep building your home’s bigger picture.",
      action: DEFAULT_PRO_FALLBACK.beforeAction,
      why: DEFAULT_PRO_FALLBACK.why,
      science: DEFAULT_PRO_FALLBACK.guidanceText,
      whyParagraphs: [DEFAULT_PRO_FALLBACK.beforeBody],
      products: [],
      resources: [],
      research: ["epaIndoorAirResearch"],
      evidenceLabel: "General guidance",
      evidenceNote: DEFAULT_PRO_FALLBACK.guidanceText
    },
    kitchenPlastics: {
      key: "kitchenPlastics", tag: "Food + beverage", title: "Keep hot food & beverages out of plastic",
      action: "This week, choose one repeat habit: use glass or ceramic for heating food and drinks, or choose a glass, ceramic, or stainless-steel cup for hot beverages. Check that the item is suitable for the heating method; never microwave stainless steel.",
      why: "Your answers point to food-contact plastic as a useful place to start. Consider where warm food or drinks touch it during cooking, serving, or everyday meals.",
      whyParagraphs: [
        "Plastic matters most when food or drinks are hot, oily, or acidic. Start where it counts: skip heating or placing hot food or drinks in plastic and move hot takeout or leftovers to glass.[1]",
        "Food-contact chemicals can migrate into food and liquids, with heat, food type, material, and contact time influencing how much.[2] This doesn’t mean plastic has harmed your family—it simply makes hot food and drinks a smart place to start.",
        "This rose to the top because your answers point to food-contact plastic as a practical place to start.",
        "Plastic contact can also happen in plastic-lined takeaway cups, microwave meal trays, and cooking bags. These examples help you notice routines; they do not mean every material or use presents the same concern."
      ],
      products: ["kitchenResetKit", "glassStorage", "stainlessSteelLunch"],
      resources: ["kitchenHazardsLearn"],
      research: ["aapPlasticizersResearch", "foodMigrationResearch"]
    },
    nonstick: {
      key: "nonstick", tag: "Cookware", title: "Replace the most-used nonstick item.",
      action: "Start with the pan you reach for most, especially if it is scratched or used on high heat. Replace it with safer alternatives like stainless steel, cast iron or ceramic coated cast iron.",
      why: "You do not need to replace everything at once. Removing the highest-use pan is the cleanest first move.",
      whyParagraphs: [
        "Many nonstick pans contain PTFE, a type of PFAS. Normal use of intact cookware appears to pose little concern. Risk is greater when pans are significantly overheated, which can generate harmful fumes [3]. If the coating is worn or damaged, consider replacing it. The calm first move is to replace your most-used or damaged pan—not every pan.",
        "PFAS exposure has been associated with reduced immune response, pregnancy-related effects, liver changes and certain cancers[2] .  Risk depends on the specific PFAS, amount, route, frequency, duration, and individual factors; a single household item does not establish an individual's risk. [1]",
        "This rose to the top because your Baseline points to it as a repeated, practical place to reduce avoidable exposure without turning the whole home into a project."
      ],
      products: ["castIron", "stainlessCookware"],
      resources: ["kitchenHazardsLearn"],
      research: ["niehsEndocrineResearch", "atsdrPfasHealthResearch", "bfrPtfeResearch"]
    },
    fragrance: {
      key: "fragrance", tag: "Fragrance", title: "Create a fragrance-free baseline.",
      action: "Start with one everyday category: laundry, cleaners, hand soap, lotion, kids’ products, or anything designed to scent the air. Choose fragrance-free.",
      why: "Fragrance is a repeated, everyday exposure. One fragrance-free swap such as laundry detergent can reduce exposure across clothing, bedding, towels, indoor air, and your family’s daily routines.",
      whyParagraphs: [
        "Fragrance is everywhere—from laundry and cleaning products to personal care, candles, and air fresheners. Because these exposures can happen every day, choosing fragrance-free is a simple place to start.",
        "Fragrance formulas can contain many ingredients that often aren't individually listed on the label. IFRA’s industry-wide inventory includes more than 3,000 fragrance chemicals. In cosmetics, for example, a mixture may be listed simply as “fragrance,” legally leaving its individual components undisclosed. [1][4] Some can trigger irritation or allergic reactions, and certain fragrance-related chemicals have raised endocrine concerns in research.[3]",
        "This rose to the top because your Baseline showed fragrance as a repeated exposure, making it an easy place to reduce what you don’t need—without overhauling your whole home."
      ],
      products: ["kitchenResetKit", "fragranceFreeSoap", "fragranceFreeLaundry"],
      resources: ["fragranceIndoorAirLearn"],
      research: ["ifraTransparencyResearch", "ewgFragranceResearch", "niehsEndocrineResearch", "fdaFragranceResearch"]
    },
    pfasFabrics: {
      key: "pfasFabrics", tag: "Fabrics + finishes", title: "Audit treated fabrics before replacing anything.",
      action: "Before your next clothing or furnishing purchase, check both the fiber and the finish, opting for natural fibers like cotton or linen, when possible. Consider what will sit against skin for long periods, and whether you need added stain- or water-repellent treatments.",
      why: "This keeps the approach calm and realistic. The first step is awareness, not panic-replacing your home.",
      whyParagraphs: [
        "Performance, water-resistant, and stain-resistant textiles can be a PFAS concern, especially when choosing new furniture, rugs, or long-contact items. Auditing first prevents panic replacement.",
        "PFAS have been used in products that resist oil, water, stains, and heat. Health evidence is strongest for specific PFAS and exposure contexts, so the practical recommendation is to avoid adding unnecessary treated items when you have a choice. [1]",
        "This rose to the top because your Baseline points to it as a repeated, practical place to reduce avoidable exposure without turning the whole home into a project.",
        "Polyester deserves a separate look from PFAS treatments. Research shows that polyester garments can shed microfibers, and studies have detected chemicals such as bisphenols in some textiles. These findings do not establish that ordinary polyester clothing causes illness. A polyester or moisture-wicking label also does not prove that a product contains PFAS. [3][4]"
      ],
      products: [],
      resources: [],
      research: ["niehsEndocrineResearch", "epaPfasResearch", "microfiberResearch", "textileBisphenolsResearch"]
    },
    dust: {
      key: "dust", tag: "Shoes + dust", title: "Leave more of the outdoors at the door.",
      action: "Start at the entrance: leave outdoor shoes by the door and use an entry mat. Add damp dusting and regular vacuuming; use a HEPA-filter vacuum if available.",
      why: "Your shoe and cleaning routine offers a practical place to reduce tracked-in dirt and the dust that settles indoors.",
      whyParagraphs: [
        "Household dust can come from both outdoors and indoors. Soil and dust brought in on shoes can carry residues, including pesticides where those products have been used. Your answers do not tell us whether pesticides are present or used around your home; they identify a routine you can adjust. [2]",
        "Source control, ventilation, filtration, entry mats, shoes-off routines, damp dusting, and HEPA vacuuming are practical ways to reduce what circulates indoors; they do not need to become a perfect cleaning schedule. [1]",
        "This rose to the top because your Baseline points to it as a repeated, practical place to reduce avoidable exposure without turning the whole home into a project."
      ],
      products: ["hepaVacuum", "airPurifier"],
      resources: ["hiddenAirLearn"],
      research: ["epaIndoorAirResearch", "epaPesticidesIndoorAirResearch"]
    },
    indoorAir: {
      key: "indoorAir", tag: "Indoor air", title: "Ventilate and filter during high-impact moments.",
      action: "Use a range hood that vents outdoors while cooking. When outdoor air is clean and conditions allow, open windows during cleaning or new-product smells. Choose fragrance-free cleaners and follow their labels.",
      why: "This is not about perfect air. It is about reducing buildup during the moments most likely to affect indoor air.",
      whyParagraphs: [
        "Cooking, cleaning, smoke, new products, paint, strong odors, and closed-up rooms can all impact indoor air quality. The goal is not perfect air; it is reducing buildup during higher-input moments.",
        "EPA indoor-air guidance emphasizes source control, ventilation, and filtration. Air cleaners can help with particles when properly sized and maintained, but they are not a complete solution for every pollutant. [1] During poor AQI or wildfire smoke events, keep windows and doors closed when it is safe to do so. Use a properly sized portable HEPA air cleaner and, if you have a compatible HVAC system, a MERV 13 filter—or the highest efficiency your system can accommodate. Follow local guidance if smoke or heat makes staying indoors unsafe. [2]",
        "This rose to the top because your Baseline points to it as a repeated, practical place to reduce avoidable exposure without turning the whole home into a project.",
        "A safety reminder for every home: never run a car in an attached garage, even with the door open. Use portable generators outdoors, more than 20 feet from doors, windows, and vents. Install carbon monoxide alarms near sleeping areas and follow their testing instructions. [3]"
      ],
      products: ["airPurifier"],
      resources: ["hiddenAirLearn", "fragranceIndoorAirLearn"],
      research: ["epaIndoorAirResearch", "epaWildfireIaqResearch", "cdcCarbonMonoxideResearch"]
    },
    mold: {
      key: "mold", tag: "Moisture + mold", title: "Treat moisture as a source-control priority.",
      action: "Fix leaks, use exhaust fans that vent outdoors, and manage indoor humidity with dehumidification when needed. Document recurring moisture and consider professional assessment for persistent musty smells or visible mold.",
      why: "Surface cleaning alone is rarely the full answer if moisture keeps returning. The source has to be addressed.",
      whyParagraphs: [
        "Moisture is the source to solve. If leaks, musty smells, or recurring damp areas are present, surface cleaning alone usually misses the reason mold can return.",
        "EPA states that molds can produce allergens and irritants, and people with asthma or allergies may be more sensitive. This does not diagnose symptoms or prove mold is present; it explains why moisture control is worth prioritizing when signs are there. [1]",
        "This rose to the top because your Baseline points to it as a repeated, practical place to reduce avoidable exposure without turning the whole home into a project.",
        "Moisture control depends on the source and conditions; opening windows is not always helpful in humid weather. [2]"
      ],
      products: ["moistureMeter", "airPurifier"],
      resources: [],
      research: ["epaIndoorAirResearch", "epaMoistureControlResearch"]
    },
    kidsPlastics: {
      key: "kidsPlastics", tag: "Kids food-contact", title: "Prioritize kid items that touch warm food or beverages daily.",
      action: "Start with the feeding item used most often, especially where warm food or liquids touch plastic. When replacing items, consider age-appropriate glass or stainless-steel options; for infants, consider glass bottles suitable for feeding and warming.",
      why: "For families, this is tangible, visible, and used every day. It is a strong place to begin without overhauling everything.",
      whyParagraphs: [
        "Kids' cups, bottles, plates, bowls, and utensils can become high-frequency food- and beverage-contact items, especially when they are used every day with warm meals or milk.",
        "Children can have higher exposure relative to body weight for some environmental chemicals, and pediatric guidance supports reducing avoidable plastic-additive exposure where practical. [1]",
        "This rose to the top because your Baseline points to it as a repeated, practical place to reduce avoidable exposure without turning the whole home into a project.",
        "To reduce warm-milk contact with plastic, consider using a clean glass feeding bottle when warming breast milk. If milk was stored in a plastic breast-milk bag, thaw it in the refrigerator and transfer it before warming. Follow safe storage times and preparation instructions; never microwave breast milk or formula. [3]",
        "For pacifiers and teethers, choose age-appropriate products and inspect them for damage. A material label alone does not establish safety."
      ],
      products: ["kitchenResetKit", "stainlessSteelLunch"],
      resources: ["hormoneTimelineLearn", "kitchenHazardsLearn"],
      research: ["aapPlasticizersResearch", "foodMigrationResearch", "cdcBreastMilkResearch"]
    },
    cleaningLaundry: { key: "cleaningLaundry", tag: "Cleaning + Laundry", title: "Simplify the cleaning and laundry routine.", action: "Switch the highest-contact items first: detergent, dryer sheets/scent beads, hand soap, and everyday surface spray.", why: "Laundry and cleaning products touch the whole household, so this is a high-leverage reset without needing a big renovation.", science: "Source control is a core indoor-air strategy; fewer scented products means fewer routine indoor inputs.", products: ["kitchenResetKit", "fragranceFreeLaundry", "fragranceFreeSoap"], resources: [], research: ["epaIndoorAirResearch", "niehsEndocrineResearch"] },
    water: { key: "water", tag: "Water", title: "Match your water filter to what is actually in your water.", action: "Use your water source, ZIP code if shared, public reports or testing, and filter certifications to choose a filter instead of guessing.", why: "A filter is only useful if it is certified for the concerns you actually have.", products: ["waterFilter"], resources: [], research: [] },
    pesticides: { key: "pesticides", tag: "Outdoor", title: "Shift from routine spraying to prevention-first pest control.", action: "Seal entry points, remove food/water sources, use targeted traps where appropriate, and reserve lower-toxicity treatments for true need.", why: "This helps solve the pest problem while avoiding unnecessary chemical use around floors, pets, kids, and food areas.", products: [], resources: [], research: [] },
    kidsToys: { key: "kidsToys", tag: "Kids", title: "Reduce soft vinyl, scented, and unknown-material toys first.", action: "Keep the favorites, but phase out items most likely to be mouthed, slept with, or used in the bath if they are soft plastic or scented.", why: "You are not clearing the playroom overnight. You are prioritizing the toys with the highest contact.", products: ["saferToys"], resources: [], research: ["aapPlasticizersResearch", "niehsEndocrineResearch"] },
    kidsTextiles: { key: "kidsTextiles", tag: "Kids", title: "Start with kids’ longest-worn textiles.", action: "Prioritize pajamas, base layers, underwear, and bedding before worrying about occasional outfits.", why: "This keeps textile changes focused on what touches skin the longest.", products: [], resources: [], research: ["niehsEndocrineResearch"] },
    textiles: { key: "textiles", tag: "Textiles", title: "Start with the longest-worn textiles.", action: "Prioritize pajamas, bedding, and base layers before occasional clothing.", why: "This keeps textile changes focused and realistic.", products: [], resources: [], research: ["niehsEndocrineResearch"] }
  };

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function cloneRecommendations() {
    return clone(RECOMMENDATION_DEFAULTS);
  }

  function pruneStaleAnswers(answers) {
    const next = Object.assign({}, answers || {});
    PARKED_QUESTION_IDS.forEach(id => { delete next[id]; });
    if (!kidsDishwareEligible(next)) delete next.kids_dishware;
    return next;
  }

  function eligibleQuestions(answers) {
    return QUESTIONS.filter(question => !question.condition || question.condition(answers));
  }

  function applicableMaxRisk(answers) {
    const pruned = pruneStaleAnswers(answers);
    return eligibleQuestions(pruned).reduce((sum, question) => {
      const scoredOptions = (question.options || []).filter(option => {
        if (!optionVisible(option, pruned)) return false;
        if (option.excludeFromDenominator || option.unscored) return false;
        return option.risk != null;
      });
      const selected = answerObjects(question, pruned)[0];
      if (selected && (selected.excludeFromDenominator || selected.unscored)) return sum;
      const maxForQuestion = scoredOptions.length ? Math.max(0, ...scoredOptions.map(option => Number(option.risk || 0))) : 0;
      return sum + maxForQuestion;
    }, 0);
  }

  function getAnswerLabels(question, answers) {
    const answer = answers[question.id];
    if (question.type === "multi") {
      const selected = Array.isArray(answer) ? answer : [];
      return (question.options || []).filter(option => selected.includes(option.value)).map(option => option.label);
    }
    const selected = (question.options || []).find(option => option.value === answer);
    return selected ? selected.label : "";
  }

  function answerObjects(question, answers) {
    const answer = answers[question.id];
    if (question.type === "multi") {
      const selected = Array.isArray(answer) ? answer : [];
      return (question.options || []).filter(option => selected.includes(option.value) && optionVisible(option, answers));
    }
    const selected = (question.options || []).find(option => option.value === answer);
    return selected && optionVisible(selected, answers) ? [selected] : [];
  }

  function microwaveSupportsKitchen(answers) {
    return ["often", "sometimes", "rarely"].includes(answers && answers.microwave_plastic);
  }

  function treatedFabricsReported(answers) {
    return ["yes_several", "one_two"].includes(answers && answers.treated_textiles_furnishings);
  }

  function preparationEligible(answers) {
    return hasAny(answers && answers.household_profile, ["pregnancy_planning"]) && answers.kids_dishware === "not_in_use_yet";
  }

  function uniqueByKey(items) {
    const seen = new Set();
    const unique = [];
    items.forEach(item => {
      if (!item || !item.key || seen.has(item.key)) return;
      seen.add(item.key);
      unique.push(item);
    });
    return unique;
  }

  function scoreBandSlug(score) {
    if (score >= 88) return "strong";
    if (score >= 72) return "solid";
    if (score >= 55) return "starting_point";
    if (score >= 40) return "opportunity";
    return "begin_gently";
  }

  function buildProfileTraits(answers, lead) {
    const household = Array.isArray(answers.household_profile) ? answers.household_profile : [];
    const homeSetup = answers.home_setup || "";
    const derived = {
      household_profile: household,
      has_kids: hasAny(household, ["babies_young_children", "school_age_teens"]),
      has_pets: household.includes("pets"),
      expecting: household.includes("pregnancy_planning"),
      allergy_sensitive_household: household.includes("allergies_asthma_sensitivities"),
      top_concerns: Array.isArray(answers.top_concerns) ? answers.top_concerns : [],
      home_setup: homeSetup || null,
      readiness_budget: answers.readiness_budget || null,
      water_source: answers.water_source || null,
      zip_code: (lead && lead.zip) || answers.zip_code_optional || null
    };
    if (homeSetup.includes("rent")) derived.ownership_status = "rent";
    else if (homeSetup.includes("own")) derived.ownership_status = "own";
    else derived.ownership_status = homeSetup ? "unknown" : null;
    if (homeSetup.includes("apartment")) derived.home_type = "apartment_condo_townhome";
    else if (homeSetup.includes("townhome")) derived.home_type = "townhome_condo";
    else if (homeSetup.includes("house")) derived.home_type = "single_family";
    else if (homeSetup === "farm_rural") derived.home_type = "farm_rural";
    else derived.home_type = homeSetup ? "other_unsure" : null;
    return derived;
  }

  function calculateResults(rawAnswers, options) {
    const answers = pruneStaleAnswers(rawAnswers);
    const qs = eligibleQuestions(answers);
    let riskSum = 0;
    const maxRisk = applicableMaxRisk(answers);
    const categoryScores = {};
    const answerSummary = {};
    const contributionSources = {};

    qs.forEach(question => {
      const objects = answerObjects(question, answers);
      answerSummary[question.id] = {
        question_key: question.id,
        question: questionTitle(question, answers),
        answer: getAnswerLabels(question, answers),
        value: answers[question.id] || null,
        section: question.section
      };
      objects.forEach(answer => {
        if (answer.unscored || answer.risk == null) return;
        riskSum += Number(answer.risk || 0);
        answerSummary[question.id].risk = (answerSummary[question.id].risk || 0) + Number(answer.risk || 0);
        Object.entries(answer.categories || {}).forEach(([category, points]) => {
          const n = Number(points || 0);
          categoryScores[category] = (categoryScores[category] || 0) + n;
          contributionSources[category] = contributionSources[category] || {};
          contributionSources[category][question.id] = (contributionSources[category][question.id] || 0) + n;
        });
      });
    });

    Object.keys(categoryScores).forEach(key => {
      if (PRO_ONLY_RESULT_KEYS.indexOf(key) !== -1) delete categoryScores[key];
    });

    const rawScore = maxRisk ? Math.round(100 - ((riskSum / maxRisk) * 100)) : 100;
    const score = Math.max(0, Math.min(100, rawScore));
    const sortedCategories = Object.entries(categoryScores)
      .filter(([key, points]) => points > 0 && FREE_RESULT_KEYS.indexOf(key) !== -1 && key !== "maintenance")
      .sort((a, b) => b[1] - a[1]);

    const meaningfulCategories = sortedCategories.filter(([, points]) => Number(points || 0) >= 2);
    let ranked = meaningfulCategories.map(([category]) => category);

    if (ranked.indexOf("kidsPlastics") !== -1 && ranked.indexOf("kitchenPlastics") !== -1 && !microwaveSupportsKitchen(answers)) {
      ranked = ranked.filter(key => key !== "kitchenPlastics");
    }

    if (ranked.length < 3) {
      sortedCategories.forEach(([category, points]) => {
        if (ranked.length >= 3 || ranked.indexOf(category) !== -1) return;
        if (Number(points || 0) > 0) ranked.push(category);
      });
    }

    if (ranked.indexOf("kidsPlastics") !== -1 && ranked.indexOf("kitchenPlastics") !== -1 && !microwaveSupportsKitchen(answers)) {
      ranked = ranked.filter(key => key !== "kitchenPlastics");
    }

    ranked = uniqueByKey(ranked.map(key => ({ key }))).map(item => item.key);

    const educational = [];
    const kidsAlreadyRanked = ranked.indexOf("kidsPlastics") !== -1;
    if (ranked.length < 3 && preparationEligible(answers) && !kidsAlreadyRanked) {
      educational.push({ key: "kidsPlastics", variant: "preparation" });
    }
    if (ranked.length + educational.length < 3) educational.push({ key: "maintenance" });

    const selected = uniqueByKey([
      ...ranked.map(key => ({ key })),
      ...educational
    ]).slice(0, 3);

    const topCategories = selected.map(item => item.key);
    const lockedCategories = sortedCategories
      .map(([category]) => category)
      .filter(category => topCategories.indexOf(category) === -1)
      .slice(0, 3);

    return {
      score,
      riskSum,
      maxRisk,
      categoryScores,
      contributionSources,
      topCategories,
      topSelection: selected,
      lockedCategories,
      answerSummary,
      profileTraits: buildProfileTraits(answers, options && options.lead),
      safety_notices: [],
      completedAt: new Date().toISOString(),
      isHighScoreOpportunities: meaningfulCategories.length === 0 && score >= 88,
      coverage: qs.map(question => question.id),
      quiz_version: QUIZ_VERSION
    };
  }

  function isLaunchReadyUrl(value) {
    const url = String(value || "").trim();
    return Boolean(url) && !/example\.com/i.test(url) && url !== "#";
  }

  function resourceMap(config) {
    return Object.assign({}, DEFAULT_RESOURCES, (config && config.resources) || {});
  }

  function dedupeLinks(links) {
    const seen = new Set();
    const unique = [];
    (links || []).forEach(link => {
      const url = String(link && link.url || "").trim();
      if (!url || seen.has(url)) return;
      seen.add(url);
      unique.push(link);
    });
    return unique;
  }

  function buildCanonicalLearnMore(rec, config) {
    const resources = resourceMap(config);
    const links = [];
    (rec.resources || []).forEach(key => {
      const item = resources[key];
      if (item && isLaunchReadyUrl(item.url) && String(item.type || "").match(/learn|download|guide|resource/i)) {
        links.push({ label: item.label, url: item.url });
      }
    });
    if (rec.merchantResourceCta && isLaunchReadyUrl(rec.merchantResourceCta.url)) {
      links.push({ label: rec.merchantResourceCta.label, url: rec.merchantResourceCta.url });
    }
    if (rec.merchantResourceCta2 && isLaunchReadyUrl(rec.merchantResourceCta2.url)) {
      links.push({ label: rec.merchantResourceCta2.label, url: rec.merchantResourceCta2.url });
    }
    return dedupeLinks(links);
  }

  function buildCanonicalHelpfulProducts(rec, answers, config) {
    const products = (config && config.products) || {};
    const traits = buildProfileTraits(answers || {}, null);
    const links = [];
    (rec.products || []).forEach(key => {
      if (["stainlessSteelLunch", "saferToys", "cottonPajamas"].indexOf(key) !== -1 && !traits.has_kids) return;
      const item = products[key];
      if (item && isLaunchReadyUrl(item.url)) {
        links.push({ label: item.label, url: item.url, disclosure: config && config.affiliateDisclosure });
      }
    });
    if (rec.merchantProductCta && isLaunchReadyUrl(rec.merchantProductCta.url)) {
      links.push({ label: rec.merchantProductCta.label, url: rec.merchantProductCta.url, disclosure: config && config.affiliateDisclosure });
    }
    return dedupeLinks(links);
  }

  function buildCanonicalResearchSources(rec, config) {
    const resources = resourceMap(config);
    const links = [];
    (rec.research || []).forEach(key => {
      const item = resources[key];
      if (item && isLaunchReadyUrl(item.url)) {
        links.push({ marker: `[${links.length + 1}]`, label: item.label, url: item.url, source_type: item.type || "research" });
      }
    });
    (rec.customSources || []).forEach(source => {
      if (isLaunchReadyUrl(source.url) && String(source.label || "").trim()) {
        links.push({ marker: `[${links.length + 1}]`, label: String(source.label).trim(), url: source.url, source_type: "research" });
      }
    });
    return dedupeLinks(links).map((link, index) => Object.assign({}, link, { marker: `[${index + 1}]` }));
  }

  function evidenceForRecommendation(rec) {
    if (rec.evidenceLabel) return { label: rec.evidenceLabel, note: rec.evidenceNote || rec.science || "" };
    const developing = { pfasFabrics: true, nonstick: true, kidsToys: true, kidsTextiles: true, textiles: true };
    if (rec.key === "maintenance") return { label: "General guidance", note: DEFAULT_PRO_FALLBACK.guidanceText };
    if (developing[rec.key]) return { label: "Developing evidence", note: "Credible evidence exists, but important questions remain about specific materials, exposures, and outcomes. This does not establish that a household routine caused harm." };
    return { label: "Well-established guidance", note: "This action aligns with consistent authoritative guidance and/or stronger human evidence for practical exposure reduction. It does not predict or determine an individual health outcome." };
  }

  function applyProState(rec, config) {
    if (!rec || rec.key !== "maintenance") return rec;
    const pro = Object.assign({}, DEFAULT_PRO_FALLBACK, (config && config.proFallback) || {});
    const launched = pro.state === "postlaunch";
    rec.tag = pro.eyebrow;
    rec.title = pro.headline;
    rec.why = pro.why;
    rec.action = launched ? pro.afterAction : pro.beforeAction;
    rec.whyParagraphs = [launched ? pro.afterBody : pro.beforeBody];
    rec.evidenceLabel = pro.guidanceLabel;
    rec.evidenceNote = pro.guidanceText;
    const ctaLabel = launched ? pro.afterCtaLabel : pro.beforeCtaLabel;
    const ctaUrl = launched ? pro.afterCtaUrl : pro.beforeCtaUrl;
    if (ctaLabel && isLaunchReadyUrl(ctaUrl)) rec.merchantResourceCta = { label: ctaLabel, url: ctaUrl };
    return rec;
  }

  function buildCanonicalRecommendation(rec, answers, results, config) {
    const working = applyProState(Object.assign({}, rec), config);
    if (working.key === "pfasFabrics" && !treatedFabricsReported(answers) && results && results.contributionSources && results.contributionSources.pfasFabrics && results.contributionSources.pfasFabrics.nonstick_cookware) {
      working.why = CROSS_CONTRIBUTION_PFAS_REASON;
    }
    const researchSources = buildCanonicalResearchSources(working, config);
    const evidence = evidenceForRecommendation(working);
    const learnMore = buildCanonicalLearnMore(working, config);
    const helpfulProducts = buildCanonicalHelpfulProducts(working, answers, config);
    return {
      key: working.key,
      variant: working.variant || null,
      tag: working.tag,
      title: working.title,
      why: working.why,
      why_paragraphs: working.whyParagraphs || working.whyBullets || [working.why],
      action: working.action,
      first_action: working.action,
      evidence_label: evidence.label,
      evidence_note: evidence.note,
      citation_markers: researchSources.map(source => source.marker),
      learn_more: learnMore,
      helpful_products: helpfulProducts,
      affiliate_disclosure: config && config.affiliateDisclosure,
      research_sources: researchSources,
      email_links: [
        ...learnMore.map(link => Object.assign({ type: "learn" }, link)),
        ...researchSources.map(link => Object.assign({ type: "research" }, link)),
        ...helpfulProducts.map(link => Object.assign({ type: "affiliate" }, link))
      ]
    };
  }

  function getApplicableCategoryKeys(answers) {
    const keys = new Set();
    eligibleQuestions(answers).forEach(question => {
      (question.options || []).forEach(option => {
        Object.keys(option.categories || {}).forEach(category => {
          if (CATEGORY_REASSURANCE[category]) keys.add(category);
        });
      });
    });
    return Array.from(keys);
  }

  function buildDoingGreatNotes(results, answers) {
    const applicable = getApplicableCategoryKeys(answers);
    const topSet = new Set(results.topCategories || []);
    const scoredLow = applicable
      .map(category => ({ category, points: Number(results.categoryScores[category] || 0) }))
      .filter(item => item.points <= 1 && !topSet.has(item.category) && !(item.category === "pfasFabrics" && !treatedFabricsReported(answers)))
      .sort((a, b) => a.points - b.points)
      .map(item => CATEGORY_REASSURANCE[item.category].good);

    const notes = [];
    if (answers.nonstick_cookware === "rarely") notes.push("Cookware: Relying on stainless, cast iron, carbon steel, or glass keeps nonstick from becoming a first priority.");
    if (results.score >= 72) notes.push("Overall Foundation: Your answers show a strong foundation. The goal now is refinement, not starting over.");
    else notes.push("Clarity: You completed the most important first step: getting clear on what matters most instead of trying to change everything at once.");
    scoredLow.forEach(note => { if (notes.indexOf(note) === -1) notes.push(note); });
    if (notes.length < 3) notes.push("Progress: You do not need perfection to make progress. A few repeatable changes can create a healthier home rhythm over time.");
    if (notes.length < 3) notes.push("Focus: Your Baseline is designed to highlight what is useful now and leave the rest for later, so this does not become another overwhelming to-do list.");
    return notes;
  }

  function buildNotToWorryNotes(results, answers) {
    const notes = [];
    const topSet = new Set(results.topCategories || []);
    if (!topSet.has("mold") && ["no", "past"].includes(answers.moisture_mold)) {
      notes.push("Moisture: You do not need to jump into mold testing if you have no recurring moisture, musty smells, leaks, or visible concerns. Just keep monitoring obvious moisture spots.");
    }
    if (!topSet.has("nonstick") && answers.nonstick_cookware && answers.nonstick_cookware !== "rarely") {
      notes.push("Cookware: You do not need to replace a full cookware set overnight. Replace the most-used or first-worn nonstick item first, then phase others out as they wear.");
    }
    if (notes.length < 2) notes.push("Spending: You do not need to buy everything we mention. Your first job is to focus on the few highest-impact changes above.");
    if (notes.length < 2) notes.push("Real Life: You do not need perfection. A couple of favorite “cheat items” can coexist with a healthier overall home rhythm.");
    return notes;
  }

  function enrichResultsForEmail(results, rawAnswers, options) {
    const answers = pruneStaleAnswers(rawAnswers);
    const recommendations = (options && options.recommendations) || cloneRecommendations();
    const config = options && options.config || {};
    const selection = results.topSelection || (results.topCategories || []).map(key => ({ key }));
    const topRecommendations = uniqueByKey(selection.map(item => {
      if (item.variant === "preparation") return Object.assign({}, PREPARATION_RESULT);
      return recommendations[item.key];
    }).filter(Boolean)).map(rec => buildCanonicalRecommendation(rec, answers, results, config));

    return Object.assign({}, results, {
      content_version: CONTENT_VERSION,
      result_type: "home_wellness_baseline",
      quiz_version: QUIZ_VERSION,
      intro: {
        eyebrow: "Home Wellness Baseline™",
        heading: "What these results mean",
        body: [
          "Your Home Wellness Baseline combines your initial Home Wellness Score with personalized priorities and practical next steps to improve your Score over time.",
          "This is a starting point, not a judgment, grade, or demand for perfection. It identifies recurring household routines that may be worth revisiting based on the available evidence and what is realistic to change.",
          "Save these results as your starting point. Human Standard is developing a way to revisit your Baseline and see how your home and routines evolve over time."
        ]
      },
      trust: {
        headline: "Research-informed. Designed for real life.",
        body: "Human Standard recommendations draw from peer-reviewed research and authoritative health guidance, then translate that evidence into practical household steps.",
        physician_reviewed: false
      },
      top_recommendations: topRecommendations,
      top_recommendation_titles: topRecommendations.map(rec => rec.title),
      doing_great_notes: buildDoingGreatNotes(results, answers).slice(0, 3),
      not_to_worry_notes: buildNotToWorryNotes(results, answers).slice(0, 2),
      safety_notices: []
    });
  }

  return {
    QUIZ_VERSION,
    CONTENT_VERSION,
    PARKED_QUESTION_IDS,
    FREE_RESULT_KEYS,
    PRO_ONLY_RESULT_KEYS,
    QUESTIONS,
    CATEGORY_REASSURANCE,
    DEFAULT_RESOURCES,
    DEFAULT_PRO_FALLBACK,
    PREPARATION_RESULT,
    CROSS_CONTRIBUTION_PFAS_REASON,
    hasAny,
    kidsDishwareEligible,
    isPregnancyOnlyHousehold,
    optionVisible,
    questionTitle,
    pruneStaleAnswers,
    eligibleQuestions,
    applicableMaxRisk,
    cloneRecommendations,
    calculateResults,
    enrichResultsForEmail,
    buildCanonicalLearnMore,
    buildCanonicalResearchSources,
    buildProfileTraits
  };
});
